import { View, TextInput, Platform, type TextInputProps } from 'react-native'
import type { getRegistrationFormStyles } from './AccountRegistrationForm.styles'

interface OrgFormTextInputProps extends TextInputProps {
  marketing: boolean
  styles: ReturnType<typeof getRegistrationFormStyles>
}

/**
 * Single-line text input used by the organization registration form.
 * On marketing web, wraps the input in a shell so RN Web does not drop the
 * background/border (styling comes from the parent form's stylesheet).
 */
export function OrgFormTextInput({ marketing, styles, ...props }: OrgFormTextInputProps) {
  if (marketing && Platform.OS === 'web') {
    return (
      <View style={styles.marketingWebFieldShell}>
        <TextInput {...props} style={styles.marketingWebFieldInput} />
      </View>
    )
  }
  return <TextInput {...props} style={styles.input} />
}
